import { CustomerDetails } from '~/components/customer-details';
import { FunnelPage } from '~/components/funnel-page';
import { Header } from '~/components/header';
import { TwoColumnGrid } from '~/components/layout';
import { useFunnel } from '~/hooks/use-funnel';
import { pickEmail } from '~/machines/telesales-funnel/emailer';
import { telesalesScreenMap } from '~/machines/telesales-funnel/screen-map';
import { copy } from './copy';
import { funnelMachine } from './machine';

export const Funnel = () => {
  const { funnel, micro, step, overrideCopy, Screen } = useFunnel({
    funnelMachine,
    screenMap: telesalesScreenMap,
    copy,
  });

  return (
    <FunnelPage funnel={funnel} micro={micro} step={step} defaultHeader={false}>
      <Header badge="Assisted Sales" backgroundColor="accent3" />
      {(funnel.matches('enrollment') || funnel.matches('billing')) && (
        <TwoColumnGrid>
          <CustomerDetails
            buttonText="Share with customer"
            emailResult={funnel.context.emailResult}
            onSubmitEditInformation={data => {
              funnel.send({ type: 'UPDATED_USER', data });
            }}
            shareButtonHandler={() => {
              funnel.send({ type: 'SEND_EMAIL', key: pickEmail({ funnel, micro }) });
            }}
            user={funnel.context.funnelPacket!.user}
          />
        </TwoColumnGrid>
      )}
      <Screen funnel={funnel} micro={micro} overrideCopy={overrideCopy} />
    </FunnelPage>
  );
};
